/**
 *
 * Qlist
 *
 */

import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';

export default {
  name: 'QaQuestionFilter',

  computed: {
    ...mapGetters('QA/QuestionList', {
      mg_qTags: 'qTags',
    }),

    c_currentCourseTag() {
      const currentCourseTag = _.find(
        this.mg_qTags,
        (courseTag) => Number(this.$route.query.courseTagId) === courseTag.courseTagId
      );
      return currentCourseTag ? currentCourseTag : {};
    },

    c_currentCourseTagName() {
      return this.c_currentCourseTag.courseTagName;
    },

    c_currentBookTags() {
      const currentBookTags = this.c_currentCourseTag.tags;
      return currentBookTags ? currentBookTags : [];
    },

    c_currentBookTag() {
      const currentBookTag = _.find(
        this.c_currentBookTags,
        (bookTag) => Number(this.$route.query.bookTagId) === bookTag.bookTagId
      );
      return currentBookTag ? currentBookTag : {};
    },

    c_currentBookTagName() {
      return this.c_currentBookTag.bookTagName;
    },
  },

  methods: {
    makeQuestionUrlParamsAndGo(params) {
      this.$emit('filter-change', params);
    },

    selectFilterLevel1(courseTagId) {
      this.makeQuestionUrlParamsAndGo({
        courseTagId,
        pageNo: 0,
      });
    },

    selectFilterLevel2(bookTagId) {
      this.makeQuestionUrlParamsAndGo({
        bookTagId,
        pageNo: 0,
      });
    },

    clearFilter() {
      this.makeQuestionUrlParamsAndGo({
        courseTagId: 0,
        bookTagId: 0,
        pageNo: 0,
      });
    },
  },

  mounted() {
    if (this.$route.query.courseTagId) {
      $(this.$refs.qaFilter).collapse('show');
    }
  },
};
